import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BackendService } from '../../core/backend.service';
import { UserCatalog, UserCatalogItem } from './user-catalog';

@Injectable({
  providedIn: 'root',
})
export class UserCatalogService {

  public catalogList: Subject<UserCatalogItem[]> = new Subject();

  constructor(private backenService: BackendService) {

  }

  public GetUserCatalogs() {
    const httpParam = new HttpParams().set('userName', localStorage.getItem('currentUser'));

    this.backenService.getBySearchParams<UserCatalog>(UserCatalog, httpParam).subscribe(result => {
      this.catalogList.next(result.catalogList);
    });

  }
}
